import { useT } from "@repo/transifex";
import { useVatLabel } from "~/hooks/use-vat-label";

import { SalesTableSection } from "./SalesTableSection";
import { type SalesByCategoriesData } from "./types";

type SalesByCategoriesSectionProps = {
  data: SalesByCategoriesData;
};

export const SalesByCategoriesSection = ({
  data
}: SalesByCategoriesSectionProps) => {
  const t = useT();
  const { vatLabel } = useVatLabel();

  return (
    <SalesTableSection
      title={t("Sales by categories (incl. {vatLabel})", { vatLabel })}
      nameLabel={t("Category Name")}
      data={data}
    />
  );
};
